import React from 'react'

const EFFECTIVE = 'June 29, 2026'

export default function Terms() {
  return (
    <section className="page">
      <div className="container">
        <h1>Terms of Use</h1>
        <p className="updated">Last updated: {EFFECTIVE}</p>

        <p>
          These Terms of Use (“Terms”) govern your use of the Heard mobile application (the “App”),
          provided by Alana .sh (“we”, “us”). By downloading or using the App you agree to these
          Terms. If you do not agree, do not use the App.
        </p>

        <h2>1. License</h2>
        <p>
          We grant you a personal, non-exclusive, non-transferable, revocable license to use the App
          on Apple-branded devices you own or control, in accordance with the Apple Media Services
          Terms and these Terms.
        </p>

        <h2>2. The content</h2>
        <p>
          Books included with the App are works in the public domain, sourced from Project Gutenberg.
          They are provided “as is” for your personal reading and listening. You are responsible for
          any EPUB files you import, and for ensuring you have the right to use them.
        </p>

        <h2>3. Subscriptions (Heard Pro)</h2>
        <ul>
          <li>Heard Pro is an auto-renewing subscription that unlocks additional voices and EPUB import.</li>
          <li>Payment is charged to your Apple ID account at confirmation of purchase.</li>
          <li>
            The subscription renews automatically unless cancelled at least 24 hours before the end of
            the current period. Your account is charged for renewal within 24 hours prior to the end of
            the period.
          </li>
          <li>
            You can manage or cancel your subscription in your device’s App Store account settings.
            Deleting the App does not cancel a subscription.
          </li>
          <li>Prices are shown in the App and may vary by region; any free trial terms are disclosed at purchase.</li>
        </ul>

        <h2>4. Acceptable use</h2>
        <p>
          You agree not to reverse engineer, resell, or misuse the App, or use it to violate any law or
          the rights of others.
        </p>

        <h2>5. Disclaimer</h2>
        <p>
          The App is provided “as is” and “as available,” without warranties of any kind, whether
          express or implied. We do not warrant that the App will be uninterrupted or error-free.
        </p>

        <h2>6. Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, Alana .sh shall not be liable for any indirect,
          incidental, or consequential damages arising from your use of the App.
        </p>

        <h2>7. Changes</h2>
        <p>
          We may update these Terms from time to time. Continued use of the App after changes take
          effect constitutes acceptance of the revised Terms.
        </p>

        <h2>8. Contact</h2>
        <p>
          Questions about these Terms? Email hello [at] alana [dot] sh.
        </p>
      </div>
    </section>
  )
}
